module.exports = __webpack_public_path__ + "img/image43.d1cc16ef.webp";